export default __webpack_public_path__ + "static/media/dell_mouse.946dd150.jpg";